import { render } from "./IndexReservation.vue?vue&type=template&id=c6af6012&scoped=true"
import script from "./IndexReservation.vue?vue&type=script&lang=js"
export * from "./IndexReservation.vue?vue&type=script&lang=js"

import "./IndexReservation.vue?vue&type=style&index=0&id=c6af6012&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6af6012"]])

export default __exports__